import React from "react";

import RichText from "./RichText";
import StateAutoRichText from './StateAutoRichText'

export default function StateProducts(props) {
  return (
    <div className="state-products stateSection">
      <div className="container-fluid">
        <h1>{props?.StateProducts?.content?.Header[0]?.headline}</h1>
        <p className="w-50">
          {props?.StateProducts?.content?.Header[0]?.subheadline}
        </p>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6">
            <div className="flex-item">
              <StateAutoRichText
                Description={
                  props?.StateProducts?.content?.Header[0]?.description
                }
              />
            </div>
          </div>
          <div className="col-sm-6">
            <img
              src={
                props?.StateProducts?.content?.Media_Object_Group[0]?.Image
                  ?.filename
              }
              className="img-fluid "
            />
          </div>
          <div className="col-sm-6 ">
            {props?.StateProducts?.content?.Media_Object_Group.map((item) => {
              return <RichText Description={item.Description} key={item.id} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
